import { planTypes } from '@/common/constants';
import { planQueryParser } from '@/common/service/flow/utils';
import { pageConfig } from '@/common/service/page-config';
import { flowTypes } from '@/common/service/page-config';

/**
 * Returns true when the page "from" param indicates a ZPA (Zoom Phone Add-on) link in Zoom Phone context.
 * don't check when the page type is edit
 */
function isZPALinkInZoomPhoneContext() {
  const { from, type } = pageConfig;
  const { fromType, category_codes = [] } = planQueryParser(from || 'pbx_ZVM');

  const isZPALink = category_codes.includes('ZPA');
  return isZPALink && fromType === planTypes.ZOOM_PHONE && type !== flowTypes.edit;
}

export { isZPALinkInZoomPhoneContext };
